module.exports = "/dashboard/_next/static/images/banner-wallet-b47d4165f6045b4f9e55ffda585c10e6.png";